var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cookie-law',{attrs:{"theme":"banner","buttonText":"Accetto","transitionName":"fade","message":"Questo sito utilizza cookies a fini statistici e per migliorare l’esperienza utente."}})
}
var staticRenderFns = []

export { render, staticRenderFns }